import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SelectChangeEvent } from '@mui/material';
import { OptionProps } from '../../view-models';
import { TextComponent, SelectComponent } from '../uiComponents';
import Button from '@mui/material/Button';
import { gritComponentStyles } from './gritComponentStyles';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { useDispatch, useSelector } from 'react-redux';
import { getClaimsDropdownList, getClaims } from '../../store';
import { ClaimComponent } from '.';
import { init_Claim, init_PersistedClaim } from '../../xmlParsing/initInterfaces';
import { Claim, PersistedClaim } from '../../xmlParsing/interfaces';
import CONSTANTS from '../../constants/constants';
import { validateClaim } from '../../utils/utils';
import ShowClaimComponent from './showClaim';

interface PersistedClaimComponentProps {
  data: PersistedClaim;
  list: PersistedClaim[];
  mode: 'edit' | 'add';
  changeHandler: (val: any) => void;
}

function PersistedClaimComponent({ data, list, mode, changeHandler }: PersistedClaimComponentProps) {
  const [modifiedData, setModifiedData] = useState<PersistedClaim>(init_PersistedClaim());
  const [newClaim, setNewClaim] = useState<Claim>(init_Claim());
  const [hasError, setError] = useState<boolean>(false);
  const [parentClaimError, setParentClaimError] = useState<string>('');
  const [helperText, setHelperText] = useState<string>('');
  const [newClaimSelection, setNewClaimSelection] = useState<string>('selectExisting');
  const [filteredList, setFilteredList] = useState<OptionProps[]>([]);
  const allClaimsDropdownList = useSelector(getClaimsDropdownList);
  const allClaims = useSelector(getClaims);
  const classes = gritComponentStyles();

  useEffect(() => {
    if (mode === 'edit') {
      setModifiedData(data);
      setError(false);
    }
    if (mode === 'add') {
      setModifiedData(init_PersistedClaim());
      if (newClaimSelection === 'selectExisting' && allClaimsDropdownList.length > 0) {
        const availableList = list.reduce(
          (acc: string[], curVal: PersistedClaim) => acc.concat([curVal.claimTypeReferenceId]),
          [],
        );
        const allClaimsList: string[] = allClaimsDropdownList.reduce(
          (acc: string[], option: OptionProps) => acc.concat(option.value),
          [],
        );
        let finalList: OptionProps[] = CONSTANTS.AAD_ATTRIBUTES.concat(
          allClaimsList.filter((item) => CONSTANTS.AAD_ATTRIBUTES.indexOf(item) < 0),
        )
          .filter((el: string) => !availableList.includes(el))
          .reduce((acc: OptionProps[], val: string) => {
            return acc.concat({ label: val, value: val });
          }, [])
          .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));

        setFilteredList(finalList);
        setError(false);
      }
      if (newClaimSelection === 'addNew') {
        setError(true);
      }
    }
  }, [data, list, mode, newClaimSelection, allClaimsDropdownList]);

  useEffect(() => {
    filteredList.length > 0 && setModifiedData({ ...modifiedData, claimTypeReferenceId: filteredList[0].value });
  }, [filteredList]);

  useEffect(() => {
    setError(validatePersistedData() || validateClaim(newClaim, allClaims));
  }, [modifiedData, filteredList, newClaimSelection, newClaim]);

  const validPartnerClaimType = (claim: string) => {
    if (claim.startsWith('extension_') && claim.trim() != 'extension_') {
      return true;
    } else if (CONSTANTS.AAD_ATTRIBUTES.includes(claim)) {
      return true;
    } else {
      return false;
    }
  };
  const validatePersistedData = () => {
    let errorFlag: boolean = false;
    if (newClaimSelection === 'selectExisting') {
      if (CONSTANTS.AAD_ATTRIBUTES.includes(modifiedData['claimTypeReferenceId'])) {
        // AAD-attributes
        if (modifiedData['partnerClaimType'] === '' || validPartnerClaimType(modifiedData['partnerClaimType'])) {
          // empty partnerClaimType || valid partnerClaimType - valid
          setParentClaimError('');
          setHelperText('');
        } else {
          // invalid partnerClaimType - invalid
          setParentClaimError('');
          setHelperText('PartnerClaimType if exists should be extension_<attribute> or valid AAD-Attributes');
          errorFlag = true;
        }
      } else {
        // non AAD-attributes
        if (modifiedData['partnerClaimType'] === '' || !validPartnerClaimType(modifiedData['partnerClaimType'])) {
          // empty partnerClaimType || invalid partnerClaimType - invalid
          setParentClaimError('');
          setHelperText('PartnerClaimType should be extension_<attribute> or valid AAD-Attributes');
          errorFlag = true;
        } else {
          // valid partnerClaimType - valid
          setParentClaimError('');
          setHelperText('');
        }
      }
    } else {
      // newClaimSelection === 'addNew'
      if (newClaim['id'] === '') {
        // claimTypeReferenceId is empty
        setParentClaimError('ClaimTypeReferenceId cannot be empty.');
        setHelperText('');
        errorFlag = true;
      } else {
        // claimTypeReferenceId is not empty
        if (allClaimsDropdownList.findIndex((option: OptionProps) => option.value === newClaim['id']) !== -1) {
          //  an ID exists in claims
          setParentClaimError(
            'There is another claim with the same ID. Click "Select from existing claimTypeReferenceId" to choose existing claims',
          );
          setHelperText('');
          errorFlag = true;
        } else if (CONSTANTS.AAD_ATTRIBUTES.includes(newClaim['id'])) {
          setParentClaimError(
            'Cannot use an AAD attribute as claimTypeReferenceId. Click "Select from existing claimTypeReferenceId" to choose AAD-attributes',
          );
          setHelperText('');
          errorFlag = true;
        } else {
          // ID does not exist, check if partnerClaimType exists
          if (modifiedData['partnerClaimType'] === '') {
            setParentClaimError('');
            setHelperText('PartnerClaimType should be extension_<attribute>');
            errorFlag = true;
          } else {
            // partnerClaimType is not empty
            if (validPartnerClaimType(modifiedData['partnerClaimType'])) {
              setParentClaimError('');
              setHelperText('');
            } else {
              setParentClaimError('');
              setHelperText('PartnerClaimType should be extension_<attribute>');
              errorFlag = true;
            }
          }
        }
      }
    }
    return errorFlag;
  };
  return (
    <>
      <h3>Persisted Claims</h3>
      {mode === 'add' && (
        <div id="add-claimTypeReferenceId">
          <FormControl>
            <RadioGroup
              row
              value={newClaimSelection}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setNewClaimSelection(e.target.value);
              }}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="selectExisting"
                control={<Radio />}
                label="Select from existing claimTypeReferenceId"
              />
              <FormControlLabel value="addNew" control={<Radio />} label="Add a new Claim" />
            </RadioGroup>
          </FormControl>
          <hr />
        </div>
      )}
      {modifiedData && (
        <div className={classes.flexCol}>
          <div>
            {mode === 'edit' && <ShowClaimComponent data={allClaims[modifiedData.claimTypeReferenceId]} />}
            {mode === 'add' && newClaimSelection === 'selectExisting' && filteredList.length > 0 && (
              <SelectComponent
                changeHandler={(e: SelectChangeEvent<string>) => {
                  setModifiedData({ ...modifiedData, claimTypeReferenceId: e.target.value });
                }}
                data={{
                  value: modifiedData['claimTypeReferenceId'] || filteredList[0]['value'],
                  label: 'Select ClaimTypeReferenceId',
                  style: { margin: 1, width: 400 },
                  options: filteredList,
                }}
              />
            )}
            {mode === 'add' && newClaimSelection === 'addNew' && (
              <ClaimComponent
                data={newClaim}
                parentClaimError={parentClaimError}
                changeHandler={(newClaim: Claim) => {
                  setNewClaim(newClaim);
                }}
              />
            )}
          </div>
          <div>
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setModifiedData({ ...modifiedData, partnerClaimType: e.target.value });
              }}
              data={{
                value: modifiedData['partnerClaimType'] || '',
                label: 'Select partnerClaimType',
                error: !!helperText,
                helperText: helperText,
              }}
            />
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setModifiedData({ ...modifiedData, defaultValue: e.target.value });
              }}
              data={{
                value: modifiedData['defaultValue'] || '',
                label: 'defaultValue',
              }}
            />
          </div>
          <footer className={classes.footer}>
            <Button
              variant="contained"
              color="primary"
              disabled={hasError}
              onClick={() => {
                if (mode === 'add' && newClaimSelection === 'selectExisting')
                  changeHandler({
                    ioclaim: { ...modifiedData, claimTypeReferenceId: modifiedData['claimTypeReferenceId'] },
                    claim: {},
                  });
                else if (mode === 'add' && newClaimSelection === 'addNew')
                  changeHandler({
                    ioclaim: { ...modifiedData, claimTypeReferenceId: newClaim['id'] },
                    claim: newClaim,
                  });
                else changeHandler({ ioclaim: modifiedData });
              }}
            >
              {mode === 'add' ? 'Add' : 'Update'}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                changeHandler(null);
              }}
            >
              Cancel
            </Button>
          </footer>
        </div>
      )}
    </>
  );
}

// export default withAITracking(reactPlugin, PersistedClaimComponent);
export default PersistedClaimComponent;
